/*
 * @@Author: zhouwei
 * @Date: 2024-09-19 14:01:39
 * @Description:
 */
import { useContext } from 'react';
import { Breadcrumbs } from '@ok/okd';

import { toLocale } from '@common/i18n';
import CurrencyInfoContext from '@pages/currencyInfo/context';

import { PARENT_MENU, PLACEHOLDER } from '../../common/context';

export default () => {
  const { currency } = useContext(CurrencyInfoContext);

  let parentMenu = null;
  const defaultParentMenu = PARENT_MENU[0];
  PARENT_MENU.forEach(({ path, name }) => {
    if (document.referrer.indexOf(path) > 0) {
      parentMenu = name;
    }
  });

  const renderMenuText = parentMenu ?? defaultParentMenu.name;

  return (
    <>
      <div className="breadcrumbs-box">
        <Breadcrumbs
          onClick={(e) => {
            if (!e.active) {
              if (parentMenu) {
                window.history.back();
              } else {
                window.location.href = defaultParentMenu.path;
              }
            }
          }}
          options={[
            {
              label: renderMenuText,
            },
            {
              label: toLocale('currency_breadcrumbs_title', {
                currencyFullName: currency?.fullName || PLACEHOLDER,
                symbol: currency?.symbol || PLACEHOLDER,
              }),
            },
          ]}
        />
      </div>
    </>
  );
};
